module.exports = __webpack_public_path__ + "img/shuffle-02.eee5fd70.svg";